import { getAppConfigSingleton } from "@expert/app-config";
import { useActiveTask, useAgentSdk } from "@/sdk";

export function usePartnerConfig() {
    const taskPartner = useActiveTask()?.partner;
    const [agentPartner] = useAgentSdk().getPartners();
    const partnerConfig = getAppConfigSingleton().getPartnersConfig;

    // Task gets priority over agent partner
    return partnerConfig(taskPartner ?? agentPartner);
}

export function usePartnerSearch() {
    const taskPartner = useActiveTask()?.partner;
    const [agentPartner] = useAgentSdk().getPartners();
    const partnerSearch = getAppConfigSingleton().getPartnerSearch;

    // Task gets priority over agent partner
    return partnerSearch?.(taskPartner ?? agentPartner);
}

export function usePartnerFeatureConfigured() {
    const { features } = usePartnerConfig();
    return features;
}

export function useGetPartnerPrograms() {
    const { programs } = usePartnerConfig();
    return programs;
}

export function useGetQueriesBySearchType(queryId: string) {
    const queriesBySearchType = usePartnerSearch()?.queriesBySearchType;
    const queryConfig = queriesBySearchType?.phoneNumber?.find((conf) => conf.query === queryId);
    return queryConfig;
}
